// extracted by mini-css-extract-plugin
export default {"middleCol":"menu_middleCol__dmLCS","container":"menu_container__0bNaD","addMenu":"menu_addMenu__JpLXS","loader":"menu_loader__JdKpt","rotation":"menu_rotation__c6HLz"};